<template>
    <rkm-layout-body title="Lista de usuário">
        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/gerenciamento-medico/List'

export default {
    components: {List},
}
</script>